module.exports = __webpack_public_path__ + "img/expostyle_0910_black.6f87f342.jpg";